import { PendingUploadFileFingerprint } from './pendingUploadStore';

/**
 * File-identity fingerprint used by the resume flow.
 *
 * We deliberately do not hash file contents — that would require reading the
 * entire video just to verify, which on a 200 MB clip costs 1–10 s and 200 MB
 * of memory. The three-tuple of (name, size, lastModified) has effectively
 * zero collision probability across distinct user videos, and `type` adds
 * one more axis of safety against the user picking, say, a re-encoded copy
 * with the same name.
 *
 * If the user re-picks a *different* file (mismatch on any field), the
 * resume offer is dismissed and a fresh session is started.
 */
export const fingerprintFile = (file: File): PendingUploadFileFingerprint => ({
  name: file.name,
  size: file.size,
  lastModified: file.lastModified,
  type: file.type,
});

export const fingerprintsMatch = (
  a: PendingUploadFileFingerprint,
  b: File | PendingUploadFileFingerprint,
): boolean => {
  const right: PendingUploadFileFingerprint =
    b instanceof File ? fingerprintFile(b) : b;
  return (
    a.name === right.name &&
    a.size === right.size &&
    a.lastModified === right.lastModified &&
    a.type === right.type
  );
};
